import React from "react";
import ArrowRight from "../../assets/svg/ArrowRight";
import PaymentProtection from "../../assets/svg/PaymentProtection";
import FlashIcon from "../../assets/svg/FlashIcon";
import useCoupon from "../../hooks/useCoupon";
import useCart from "../../hooks/useCart";
import useWallet from "../../hooks/useWallet";
import useLoader from "../../hooks/useLoader";
import axiosPrivate from "../../axios/axiosPrivate";
import { useNavigate } from "react-router-dom";

// Shown when the wallet covers the whole order: one button to place it, no card needed.
const PlaceOrderWallet = ({ payable }) => {
  const { cartData } = useCart();
  const { couponData } = useCoupon();
  const { useWalletCredit } = useWallet();
  const { setLoading } = useLoader();
  const navigate = useNavigate();

  const placeOrder = async () => {
    try {
      const couponApplied = couponData?.applied;
      const couponCode = couponData?.appliedCoupon?.coupon_name;
      const cart = [];
      cartData?.items?.map((data) => {
        const isUpsell = data?.properties?.upsell_discount === "true";
        const upsellPrice = data?.properties?.upsell_price;
        cart?.push({
          variant_id: data?.variant_id,
          quantity: data?.quantity,
          original_price: data?.price,
          ...(isUpsell && upsellPrice && { price: upsellPrice }),
        });
      });

      const payload = {
        cart,
        couponApplied,
        couponCode,
        payment_method: "online",
        osName: "WEB",
        useWallet: useWalletCredit,
      };

      setLoading(true);
      const response = await axiosPrivate.post("/orders/create-order", payload);

      if (response?.data?.walletPaid) {
        setLoading(false);
        navigate("/thank-you", {
          state: { draftOrderId: response?.data?.draftOrderId },
          replace: true,
        });
        return;
      }
      // Not fully covered after all: send them back to the card options.
      setLoading(false);
    } catch (error) {
      console.log(error?.response?.data || error?.message);
      setLoading(false);
    }
  };

  return (
    <div
      className="py-4 flex justify-between gap-2 items-start cursor-pointer hover:bg-gray-50"
      onClick={placeOrder}
    >
      <div className="flex items-start gap-2">
        <div className="border border-1 px-[3px] py-[2px] border-gray-400 rounded-[4px]">
          <PaymentProtection width={18} height={18} />
        </div>
        <div>
          <div className="flex items-center gap-[2px] break-words flex-wrap">
            <p className="text-[16px] supreme-medium">Place order</p>
            <FlashIcon width={14} height={14} className="text-blue-500" />
          </div>
          <p className="text-[12px] general-sans-regular text-[#238017] mt-1">
            Paid fully from your wallet
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <p className="text-[16px] supreme-bold">₹0</p>
        <ArrowRight width={14} height={14} className="fill-gray-500" />
      </div>
    </div>
  );
};

export default PlaceOrderWallet;
